// -- import * as _ from "lodash-es"
import Vue from "vue"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "SEI_CustTable"
const content_type_credit = "sPlant_Customer_Credit"
const content_type_Temp_credit = "sPlant_Temp_Customer_Credit"

const create = function () {
  return {
    content_type: "muji"
  }
}
const descriptor = {
  name: {
    type: "string",
    required: true,
    validator: (rule, value) => value === "muji"
  },
  age: {
    type: "number",
    asyncValidator: (rule, value) => {
      return new Promise((resolve, reject) => {
        api
          .request({
            url: biz_data_helper.get_endpoint("test_fetch").url,
            parameters: {
              c: "a666"
            }
          })
          .then(res => {


            if (value == res.data[0].echo) {
              resolve(res)
            } else {
              reject("测试没通过")
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
const biz_data_credit = new biz_data_helper.base_entity_helper(
  content_type_credit,
  create,
  descriptor
)
const biz_data_temp_credit = new biz_data_helper.base_entity_helper(
  content_type_Temp_credit,
  create,
  descriptor
)

const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: {
        width: "80px"
      }
    },
    {
      key: "AccountNum",
      label: "客户帐户",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "客户名称",
      sortable: true
    },
    {
      key: "Currency",
      label: "币种",
      sortable: true
    },
    {
      key: "FromDate",
      label: "开始日期",
      sortable: true,
      type: "date"
    },
    {
      key: "ToDate",
      label: "结束日期",
      sortable: true,
      type: "date"
    },
    {
      key: "CreditMax",
      label: "信用额度",
      sortable: true,
      type: "number",
      _precise: 2
    },
    {
      key: "dispUsedCreditAmount",
      label: "已用信用额度",
      sortable: true,
      type: "number",
      _precise: 2
    },
    {
      key: "description",
      label: "备注"
    },
    {
      key: "CustomerCreditApprover",
      label: "审批人",
      sortable: true
    },
    {
      key: "is_approved",
      label: "审批状态",
      sortable: true,
      type: "state",
      state_control: "is_approved",
      context: ["待审批", "已审批"]
    },
    {
      key: "ApprovedState",
      label: "审批状态名称",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId",
      formatter: (value, key, item) => {
        if (item.is_approved) {
          item.ApprovedState = "已审批"
          return "已审批"
        }
        else {
          item.ApprovedState = "待审批"
          return "待审批"
        }
      }
    },
    {
      key: "credit_Id",
      label: "操作",
      type: "button",
      button: {
        type: "text",
        class: "cell_button",
        label: "设置",
        icon_class: "iconfont icon-edit"
      }
    }
  ],
  credit_fields: [
    {
      key: "id",
      label: "编号"
    },
    {
      key: "AccountNum",
      label: "客户帐户"
    },
    {
      key: "CreditMax",
      label: "信用额度",
      type: "number",
      _precise: 2
    },
    {
      key: "is_approved",
      label: "审批状态"
    },
    {
      key: "description",
      label: "备注"
    },
    {
      key: "FromDate",
      label: "开始日期",
      type: "date"
    },
    {
      key: "ToDate",
      label: "结束日期",
      type: "date"
    }
  ],
  detail_fields: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      type: "button",
      button: {
        type: "text"
      }
    },
    // {
    //   key: "Credit_Id",
    //   label: "信用编号",
    //   sortable: true
    // },
    {
      key: "CreditMax",
      label: "信用额度",
      sortable: true,
      type: "number",
      _precise: 2
    },
    {
      key: "FromDate",
      label: "开始日期",
      sortable: true,
      type: "date"
    },
    {
      key: "ToDate",
      label: "结束日期",
      sortable: true,
      type: "date"
    },

    {
      key: "description",
      label: "备注"
    },

    {
      key: "CustomerTempCreditApprover",
      label: "审批人",
      sortable: true
    },
    {
      key: "is_approved",
      label: "审批状态",
      sortable: true,
      type: "state",
      state_control: "is_approved",
      context: ["待审批", "已审批"]
    },
    {
      key: "ApprovedState",
      label: "审批状态名称",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId",
      formatter: (value, key, item) => {
        if (item.is_approved) {
          item.ApprovedState = "已审批"
          return "已审批"
        }
        else {
          item.ApprovedState = "待审批"
          return "待审批"
        }
      }
    },
  ]
}

const dataForm = {
  id: "",
  AccountNum: "",
  CreditMax: 0,
  FromDate: "", //开始日期
  ToDate: "", //结束日期
  description: ""
}
const dataForm1 = {
  id: "",
  Credit_Id: "",
  CreditMax: 0,
  FromDate: "", //开始日期
  ToDate: "", //结束日期
  description: ""
}

///前端验证
const rules = {}
const rules1 = {}
const methods = {
  ///post
  async saveTempCredit(_params) {
    let batch_actions = []
    if (!_params.id) {
      batch_actions.push(
        biz_data_temp_credit
          .insertAction({
            params: _params,
            fields: _.map(fields.detail_fields, "key")
          })
          .action({ output_last_item_map: { id: "id" } })
      )
    } else {
      batch_actions.push(
        biz_data_temp_credit
          .updateAction({
            params: _params,
            fields: _.map(fields.detail_fields, "key")
          })
          .action({ output_last_item_map: { id: "id" } })
      )
    }
    let so_approve_biz_data = new biz_data_helper.base_entity_helper(
      "sp_updateApproveStatus",
      {},
      {}
    )
    let credit_approve_form = {
      itemId: _params.id,
      documentType: "CustomerTempCredit",
      approveType: "",
      documentCreateByUsername: Vue.prototype.$global.global_data.local_username
    }
    batch_actions.push(
      so_approve_biz_data
        .execAction({
          params: credit_approve_form,
          fields: ["id"]
        })
        .action({
          mixin_last_item_map: {
            itemId: "id"
          }
        })
    )

    let result = await api.query_batch({
      actions: batch_actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return result.data.BatchResult.Actions[0].Result.Data
    } else {
      return null
    }
  },
  async saveCredit(_params) {
    let batch_actions = []
    if (!_params.id) {
      batch_actions.push(
        biz_data_credit
          .insertAction({
            params: _params,
            fields: _.map(fields.credit_fields, "key")
          })
          .action({ output_last_item_map: { id: "id" } })
      )
    } else {
      batch_actions.push(
        biz_data_credit
          .updateAction({
            params: _params,
            fields: _.map(fields.credit_fields, "key")
          })
          .action({ output_last_item_map: { id: "id" } })
      )
    }

    let so_approve_biz_data = new biz_data_helper.base_entity_helper(
      "sp_updateApproveStatus",
      {},
      {}
    )
    let credit_approve_form = {
      itemId: _params.id,
      documentType: "CustomerCredit",
      approveType: "",
      documentCreateByUsername: Vue.prototype.$global.global_data.local_username
    }
    batch_actions.push(
      so_approve_biz_data
        .execAction({
          params: credit_approve_form,
          fields: ["id"]
        })
        .action({
          mixin_last_item_map: {
            itemId: "id"
          }
        })
    )

    let result = await api.query_batch({
      actions: batch_actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return result.data.BatchResult.Actions[0].Result.Data
    } else {
      return null
    }
  },
  ///get

  async getData(_params) {
    let action = biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields.default, "key")
      })
      .action({})

    let _action2_fields = _.map(fields.credit_fields, "key")
    _action2_fields.push("fcGetCustomerCreditApprover(t.id)")
    let action2 = biz_data_credit
      .selectAction({
        params: {
          id: {
            ">": 0
          }
        },
        fields: _action2_fields
      })
      .action({})
    let batch_actions = [action, action2]

    let result = await api.query_batch({
      actions: batch_actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      //返回组合数据
      return this.DataHandle(
        result.data.BatchResult.Actions[0].Result.Data[0],
        result.data.BatchResult.Actions[1].Result.Data[0]
      )
    } else {
      return null
    }
  },
  async getTempData(_params) {
    let _fields = _.map(fields.detail_fields, "key")
    _fields.push("Credit_Id")
    _fields.push("fcGetCustomerTempCreditApprover(t.id)")

    let result = await biz_data_temp_credit
      .selectAction({
        params: _params,
        fields: _fields
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },

  // 数据整合
  async DataHandle(cust_data, credit_data) {
    for (var i in cust_data) {
      let obj = _.find(credit_data, {
        AccountNum: cust_data[i].AccountNum
      })

      if (obj) {
        cust_data[i].CreditMax = obj.CreditMax
        cust_data[i].is_approved = obj.is_approved
        cust_data[i].description = obj.description
        cust_data[i].FromDate = obj.FromDate
        cust_data[i].ToDate = obj.ToDate
        cust_data[i].credit_Id = obj.id
        cust_data[i].fcGetCustomerCreditApprover =
          obj.fcGetCustomerCreditApprover
      } else {
        cust_data[i].CreditMax = 0
        cust_data[i].credit_Id = ""
        cust_data[i].fcGetCustomerCreditApprover = ""
      }
    }
    return cust_data
  },
  //状态更改
  async changeState(_data) {
    let datas = _data.selected_items
    switch (_data.state) {
      case "approved":
        //审批
        for (var i in datas) {
          if (datas[i].credit_Id != "") {
            datas[i].is_approved = true
          }
        }
        break
      case "unapproved":
        for (var i in datas) {
          if (datas[i].credit_Id != "") {
            datas[i].is_approved = false
          }
        }
        break
      default:
        break
    }
    let actions = []
    for (var i in datas) {
      if (datas[i].credit_Id != "") {
        const update_status_biz_data = new biz_data_helper.base_entity_helper(
          "update_approve_status",
          {},
          {}
        )
        actions.push(
          update_status_biz_data
            .execAction({
              params: {
                IsApproved: datas[i].is_approved == true ? 1 : 0,
                ApproveBy: Vue.prototype.$global.global_data.local_username,
                status_id: datas[i].status_id
              },
              fields: ["is_update_ok"]
            })
            .action({
              output_last_item_map: {
                is_update_ok: "is_update_ok"
              }
            })
        )
        let action = biz_data_credit
          .approveAction({
            params: {
              id: datas[i].credit_Id,
              is_approved: datas[i].is_approved
            },
            fields: _.map(fields.credit_fields, "key")
          })
          .action({ rollback_when: { is_update_ok: { "=": 1 } } })
        actions.push(action)
      }
    }

    let batch_actions = actions

    let result = await api.query_batch({
      actions: batch_actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      //返回组合数据
      return true
      //return this.DataHandle(result.data.BatchResult.Actions[0].Result.Data[0], result.data.BatchResult.Actions[1].Result.Data[0]);
    } else {
      return false
    }
  },
  async changeTempState(_data) {
    let datas = _data.selected_items
    switch (_data.state) {
      case "approved":
        //审批
        for (var i in datas) {
          datas[i].is_approved = true
        }
        break
      case "unapproved":
        for (var i in datas) {
          datas[i].is_approved = false
        }
        break
      default:
        break
    }
    let actions = []
    for (var i in datas) {
      const update_status_biz_data = new biz_data_helper.base_entity_helper(
        "update_approve_status",
        {},
        {}
      )
      actions.push(
        update_status_biz_data
          .execAction({
            params: {
              IsApproved: datas[i].is_approved == true ? 1 : 0,
              ApproveBy: Vue.prototype.$global.global_data.local_username,
              status_id: datas[i].status_id
            },
            fields: ["is_update_ok"]
          })
          .action({
            output_last_item_map: {
              is_update_ok: "is_update_ok"
            }
          })
      )
      let action = biz_data_temp_credit
        .approveAction({
          params: {
            id: datas[i].id,
            is_approved: datas[i].is_approved
          },
          fields: _.map(fields.detail_fields, "key")
        })
        .action({ rollback_when: { is_update_ok: { "=": 1 } } })
      actions.push(action)
    }

    let batch_actions = actions

    let result = await api.query_batch({
      actions: batch_actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      //返回组合数据
      return true
      //return this.DataHandle(result.data.BatchResult.Actions[0].Result.Data[0], result.data.BatchResult.Actions[1].Result.Data[0]);
    } else {
      return false
    }
  },
  ///del so items
  async deleteItemData(items) {
    let _actions = []

    _.each(items, t => {
      _actions.push(
        biz_data_temp_credit
          .deleteAction({
            params: {
              id: t.id
            }
          })
          .action({})
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return true
    } else {
      return false
    }
  }
}
export { biz_data, dataForm, dataForm1, fields, methods, rules, rules1 };

